import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import { Trash } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import CardCollapsibleWrapper from "ds/components/Card/Collapsible/components/Wrapper";
import CardCollapsibleContent from "ds/components/Card/Collapsible/components/Content";

import DraftForm from "./DraftForm";
import ContextMountedFilesListItemHeader from "./Header";
import { ContextMountedFilesListItemRegularProps } from "./types";

const ContextMountedFilesListItemDraft = ({
  item,
  onRemoveFileDraft,
  onOpenDetailsDrawer,
  isCollapsed,
  toggle,
}: ContextMountedFilesListItemRegularProps) => {
  const { formState } = useFormContext();
  const handleToggle = useCallback(() => {
    toggle();
  }, [toggle]);

  return (
    <CardCollapsibleWrapper isCollapsed={isCollapsed} onToggle={handleToggle} withTransition>
      <ContextMountedFilesListItemHeader
        item={item}
        isCollapsed={isCollapsed}
        onOpenEditDrawer={onOpenDetailsDrawer}
      >
        <Box align="center" justify="end">
          <ButtonIcon
            onPress={onRemoveFileDraft}
            icon={Trash}
            disabled={formState.isSubmitting}
            variant="ghostDanger"
          >
            Delete
          </ButtonIcon>
        </Box>
      </ContextMountedFilesListItemHeader>
      <CardCollapsibleContent hasHeader>
        <DraftForm onCancel={onRemoveFileDraft} />
      </CardCollapsibleContent>
    </CardCollapsibleWrapper>
  );
};

export default ContextMountedFilesListItemDraft;
